import isFunction from 'lodash/isFunction'
import map from 'lodash/map'
import type { ReactNode } from 'react'
import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import type { TabsProps } from 'react-bootstrap/Tabs'

export type TabNavProps = {
  children?: ReactNode | ((props: { selectedTab: string }) => ReactNode)
  value?: string
  onChange?: (key: string) => void
  tabs?: string[]
} & Pick<TabsProps, 'variant' | 'className'>

export const TabNav = ({ children, value, onChange, tabs, variant = 'pills', className }: TabNavProps) => {
  const [selectedTab, setSelectedTab] = React.useState(value)
  const onSelect = (key: string) => {
    setSelectedTab(key)
    onChange?.(key)
  }

  return (
    <>
      <div>
        <Tabs className={className} variant={variant} defaultActiveKey={selectedTab} onSelect={onSelect}>
          {map(tabs, (tabName) => (
            <Tab key={tabName} eventKey={tabName} title={tabName} />
          ))}
        </Tabs>
      </div>
      {isFunction(children) ? children({ selectedTab }) : children}
    </>
  )
}
